// src/components/CookiePolicy.tsx
import { Paper, Title, Text, Stack, ScrollArea, Box } from '@mantine/core';

function CookiePolicy() {
	return (
		<Box h='calc(100vh - 92px)'>
			<ScrollArea h='100%' type='scroll'>
				<Paper p='md' radius='md' withBorder>
					<Stack gap='md'>
						<Title order={2}>Cookie Policy</Title>
						<Text size='sm'>Last updated: January 21, 2025</Text>

						<Stack gap='xl'>
							<section>
								<Text fw={500} size='lg'>
									1. About This Policy
								</Text>
								<Text size='sm'>
									This Cookie Policy explains how 99 Solutions
									("we", "our", or "us") uses data storage
									technologies like cookies and local storage
									in our Bill Tracker mobile application.
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									2. What Are Local Storage and Cookies?
								</Text>
								<Text size='sm'>
									Mobile applications use local storage and
									sometimes cookies to store information
									directly on your device. This helps us
									provide you with a better user experience
									and remember your preferences.
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									3. How We Use Data Storage
								</Text>
								<Text size='sm'>
									In Bill Tracker, we use local storage to:
								</Text>
								<Text size='sm' component='ul' pl='md' mt='xs'>
									<li>
										Save your bills and payment information
										locally on your device
									</li>
									<li>
										Remember your app preferences and
										settings
									</li>
									<li>Maintain your session state</li>
									<li>Improve app performance</li>
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									4. Types of Data We Store
								</Text>
								<Text size='sm'>
									We store the following types of data:
								</Text>
								<Text size='sm' component='ul' pl='md' mt='xs'>
									<li>
										Bill information (names, amounts, dates)
									</li>
									<li>
										App preferences (theme settings, display
										options)
									</li>
									<li>
										Technical data necessary for app
										functionality
									</li>
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									5. Your Control Over Your Data
								</Text>
								<Text size='sm'>
									You can clear all locally stored data by:
								</Text>
								<Text size='sm' component='ul' pl='md' mt='xs'>
									<li>
										Using the app's built-in data management
										features
									</li>
									<li>
										Clearing app data through your device
										settings
									</li>
									<li>Uninstalling the application</li>
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									6. Updates to This Policy
								</Text>
								<Text size='sm'>
									We may update this Cookie Policy from time
									to time. We will notify you of any changes
									by posting the new Cookie Policy on this
									page and updating the "Last Updated" date.
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									7. Contact Us
								</Text>
								<Text size='sm'>
									If you have any questions about our Cookie
									Policy, please contact us at
									support@99solutions.com
								</Text>
							</section>
						</Stack>
					</Stack>
				</Paper>
			</ScrollArea>
		</Box>
	);
}

export default CookiePolicy;
